import React, { useState } from "react";
import "./index.scss";
import { ReactComponent as CloseIcon } from "../../../images/close_icon.svg";
import { ReactComponent as FeedSuccess } from "../../../images/success.svg";
import StepButton from "../../common/StepButton";
import Modal from "react-modal";
import useDeviceDetect from "../../common/useDeviceDetect";

const SuccessModal = ({ isOpen =true, selectPaymentOption,paymentStatusData,selectedPaymentOption,setSelectedPaymentOption,setIsOpen,...props }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { screenWidth } = useDeviceDetect()

  const isPayMonthtrue=()=>{
   
   
    if (selectedPaymentOption?.payMonthly === false && paymentStatusData[0]?.is_finance_available ===false) {
      document.querySelector("#Pay_on_the_Day").checked = true;
      document.querySelector("#Pay_Monthly").checked=false
  }
  }

  return (
    <>
      {screenWidth < 768
        ?
        <Modal
          isOpen={isOpen}
          className={"animate-bottom"}
          style={{
            overlay: {
              padding: '20px',
              background: "rgba(0, 0, 0, 0.5)"
            },
            content: {
              borderRadius: "30px",
              height: "fit-content",
              width: "90%",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)"
            },
          }}
        >
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                width: "100%",
              }}
            >
              <CloseIcon
                className="cursor-pointer"
                onClick={() => {
                  setIsOpen(false);
                }}
              />
            </div>
            <div className="feedback-popup-container mt-3">
              <FeedSuccess />
              <h1>{props.title}</h1>
              <p className="mb-0">{props.subTitle}</p>
              <div style={{ display: 'flex', alignItems: "center", justifyContent: 'center', width: '100%' }}>
                <StepButton blue={true} label={"Done"} onClick={() => setIsOpen(false)} />
              </div>
            </div>
          </>
        </Modal>
        :
        <Modal
          isOpen={isOpen}
          style={{
            overlay: {
              padding: '20px',
              background: "rgba(0, 0, 0, 0.5)"
            },
            content: {
              borderRadius: "30px",
              height: "fit-content",
              width: "30%",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)"
            },
          }}
        >
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                width: "100%",
              }}
            >
              <CloseIcon
                className="cursor-pointer"
                onClick={() => {
                  setIsOpen(false);
                }}
              />
            </div>
            <div className="feedback-thanks-popup-container mt-3">
              <FeedSuccess />
              <h1>{props.title}</h1>
              <p className="mb-0 mt-3">{props.subTitle}</p>

              <div style={{ display: 'flex', alignItems: "center", justifyContent: 'center', width: '100%' }}>
                <StepButton blue={true} label={"Done"} onClick={() =>{
                  setIsOpen(false)
                   isPayMonthtrue()
                  }
                }  />
              </div>
            </div>
          </>
        </Modal>
      }

    </>
  );
};

export default SuccessModal;
